/* COCCOLA — interazioni (vanilla, nessuna libreria) */
(function () {
  'use strict';
  var riduci = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- comparsa allo scroll ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.cc-reveal:not(.cc-visibile)');
    if (!els.length) return;
    if (riduci || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('cc-visibile'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('cc-visibile'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- parallax morbido hero ---------- */
  function initParallax() {
    var els = document.querySelectorAll('[data-cc-parallax]');
    if (!els.length || riduci) return;
    var tick = false;
    function aggiorna() {
      els.forEach(function (el) {
        var k = parseFloat(el.getAttribute('data-cc-parallax')) || 0;
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        el.style.setProperty('--cc-par', (r.top * -k / 10).toFixed(1) + 'px');
      });
      tick = false;
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(aggiorna); } }, { passive: true });
    aggiorna();
  }

  /* ---------- neve leggera ---------- */
  function initNeve() {
    if (riduci) return;
    document.querySelectorAll('[data-cc-neve]').forEach(function (box) {
      if (box.childElementCount) return;
      var n = parseInt(box.getAttribute('data-cc-neve'), 10) || 0;
      for (var i = 0; i < n; i++) {
        var s = document.createElement('span');
        var size = 3 + Math.random() * 6;
        s.style.left = (Math.random() * 100) + '%';
        s.style.width = s.style.height = size + 'px';
        s.style.opacity = (0.35 + Math.random() * 0.5).toFixed(2);
        s.style.animationDuration = (9 + Math.random() * 12).toFixed(1) + 's';
        s.style.animationDelay = (-Math.random() * 20).toFixed(1) + 's';
        box.appendChild(s);
      }
    });
  }

  /* ---------- scena "momenti" ---------- */
  function initMomenti() {
    document.querySelectorAll('[data-cc-momenti]').forEach(function (sez) {
      var voci = sez.querySelectorAll('.cc-momento');
      var foto = sez.querySelectorAll('.cc-momenti__visivo img');
      var etichetta = sez.querySelector('.cc-momenti__etichetta');
      if (!voci.length || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var i = Array.prototype.indexOf.call(voci, en.target);
          voci.forEach(function (v, j) { v.classList.toggle('cc-attivo', j === i); });
          foto.forEach(function (f, j) { f.classList.toggle('cc-attiva', j === i); });
          if (etichetta) etichetta.textContent = en.target.getAttribute('data-etichetta') || '';
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      voci.forEach(function (v) { io.observe(v); });
    });
  }

  /* ---------- conto alla rovescia ---------- */
  function initConto() {
    document.querySelectorAll('[data-cc-scadenza]').forEach(function (box) {
      var fine = new Date(box.getAttribute('data-cc-scadenza') + 'T23:59:59').getTime();
      if (isNaN(fine)) { box.hidden = true; return; }
      var c = { g: box.querySelector('[data-g]'), o: box.querySelector('[data-o]'), m: box.querySelector('[data-m]') };
      function giro() {
        var diff = fine - Date.now();
        if (diff <= 0) { box.hidden = true; return; }
        c.g.textContent = Math.floor(diff / 864e5);
        c.o.textContent = Math.floor(diff / 36e5) % 24;
        c.m.textContent = Math.floor(diff / 6e4) % 60;
      }
      giro(); setInterval(giro, 30000);
    });
  }

  /* ---------- prodotto: varianti, prezzo, galleria ---------- */
  function soldi(cents, fmt) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return (fmt || '€{{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v);
  }

  function initProdotto() {
    document.querySelectorAll('[data-cc-prodotto]').forEach(function (box) {
      var datiEl = box.querySelector('[data-cc-varianti]');
      if (!datiEl) return;
      var varianti; try { varianti = JSON.parse(datiEl.textContent); } catch (e) { return; }
      var fmt = box.getAttribute('data-cc-formato');
      var inputId = box.querySelector('input[name="id"]');
      var bottoni = box.querySelectorAll('[data-cc-aggiungi]');
      var prezzi = document.querySelectorAll('[data-cc-prezzo="' + box.id + '"]');
      var confronti = box.querySelectorAll('[data-cc-confronto]');
      var stock = box.querySelector('[data-cc-stock]');
      var nomeScelto = box.querySelectorAll('[data-cc-scelto]');
      var testoOk = box.getAttribute('data-cc-testo-ok') || 'Aggiungi al carrello';
      var testoNo = box.getAttribute('data-cc-testo-no') || 'Esaurito';

      function scelte() {
        var out = [];
        box.querySelectorAll('[data-cc-opzione]').forEach(function (grp) {
          var sel = grp.querySelector('input:checked');
          out[parseInt(grp.getAttribute('data-cc-opzione'), 10)] = sel ? sel.value : null;
        });
        return out;
      }

      function aggiorna(cambiaFoto) {
        var s = scelte();
        var v = varianti.find(function (x) {
          return x.options.every(function (o, i) { return s[i] === undefined || s[i] === null || s[i] === o; });
        });
        nomeScelto.forEach(function (el) {
          var i = parseInt(el.getAttribute('data-cc-scelto'), 10);
          var inp = box.querySelector('[data-cc-opzione="' + i + '"] input:checked');
          if (inp) el.textContent = inp.getAttribute('data-etichetta') || inp.value;
        });
        if (!v) {
          bottoni.forEach(function (b) { b.disabled = true; b.querySelector('span').textContent = 'Non disponibile'; });
          return;
        }
        if (inputId) inputId.value = v.id;
        prezzi.forEach(function (p) { p.textContent = soldi(v.price, fmt); });
        confronti.forEach(function (c) {
          var mostra = v.compare_at_price && v.compare_at_price > v.price;
          c.hidden = !mostra;
          var s2 = c.querySelector('s'); if (s2 && mostra) s2.textContent = soldi(v.compare_at_price, fmt);
          var t = c.querySelector('.cc-tag'); if (t && mostra) t.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
        });
        bottoni.forEach(function (b) {
          b.disabled = !v.available;
          var sp = b.querySelector('span'); if (sp) sp.textContent = v.available ? testoOk : testoNo;
        });
        if (stock) {
          var soglia = parseInt(stock.getAttribute('data-soglia'), 10) || 10;
          var q = v.inventory_quantity;
          stock.classList.toggle('cc-stock--basso', q > 0 && q <= soglia);
          if (!v.available) { stock.hidden = true; }
          else { stock.hidden = false; stock.textContent = (q > 0 && q <= soglia) ? stock.getAttribute('data-testo-basso').replace('[n]', q) : stock.getAttribute('data-testo-ok'); }
        }
        if (cambiaFoto && v.featured_media_id) mostraMedia(box, v.featured_media_id, v.featured_image);
        if (box.hasAttribute('data-cc-url') && window.history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
        }
      }

      box.addEventListener('change', function (e) { if (e.target.closest('[data-cc-opzione]')) aggiorna(true); });
      aggiorna(false);
    });
  }

  function mostraMedia(box, mediaId, fallbackSrc) {
    var gal = box.querySelector('[data-cc-galleria]') || box;
    var mini = gal.querySelector('[data-cc-media="' + mediaId + '"]');
    if (mini) { mini.click(); return; }
    var img = gal.querySelector('[data-cc-img-principale]');
    if (img && fallbackSrc) { img.removeAttribute('srcset'); img.src = fallbackSrc + (fallbackSrc.indexOf('?') > -1 ? '&' : '?') + 'width=1200'; }
  }

  function initGalleria() {
    document.querySelectorAll('[data-cc-galleria]').forEach(function (gal) {
      var img = gal.querySelector('[data-cc-img-principale]');
      var mini = Array.prototype.slice.call(gal.querySelectorAll('[data-cc-media]'));
      if (!img || !mini.length) return;
      var attuale = 0;
      function vai(i) {
        attuale = (i + mini.length) % mini.length;
        var b = mini[attuale];
        mini.forEach(function (m) { m.classList.toggle('cc-attiva', m === b); });
        img.style.opacity = 0;
        setTimeout(function () {
          img.removeAttribute('srcset');
          img.src = b.getAttribute('data-src');
          img.alt = b.getAttribute('data-alt') || '';
          img.onload = function () { img.style.opacity = 1; };
          setTimeout(function () { img.style.opacity = 1; }, 400);
        }, 160);
        b.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: riduci ? 'auto' : 'smooth' });
      }
      mini.forEach(function (b, i) { b.addEventListener('click', function () { vai(i); }); });
      var prev = gal.querySelector('[data-cc-prev]'), next = gal.querySelector('[data-cc-next]');
      if (prev) prev.addEventListener('click', function () { vai(attuale - 1); });
      if (next) next.addEventListener('click', function () { vai(attuale + 1); });
      var x0 = null;
      img.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      img.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) vai(attuale + (dx < 0 ? 1 : -1)); x0 = null; });
    });
  }

  /* ---------- barra "compra" fissa su mobile ---------- */
  function initBarra() {
    var bar = document.querySelector('[data-cc-barra]');
    var target = document.querySelector('[data-cc-form-principale]');
    if (!bar || !target || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (en) { bar.classList.toggle('cc-mostra', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(target);
    var btn = bar.querySelector('button');
    if (btn) btn.addEventListener('click', function () { var b = target.querySelector('[data-cc-aggiungi]'); if (b && !b.disabled) b.click(); else target.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
  }


  /* ---------- giostra in loop (vetrina + recensioni) ----------
     Il contenuto è ripetuto 3 volte: si parte dalla copia centrale e,
     quando si arriva a una copia esterna, si salta in silenzio a quella centrale. */
  function initGiostra(root) {
    (root || document).querySelectorAll('[data-cc-giostra]:not([data-cc-pronta])').forEach(function (box) {
      box.setAttribute('data-cc-pronta', '');
      box.querySelectorAll('[data-cc-copia] a, [data-cc-copia] button').forEach(function (a) { a.tabIndex = -1; });
      var bin = box.querySelector('.cc-giostra__binario');
      var copie = parseInt(box.getAttribute('data-cc-copie'), 10) || 3;
      var vel = parseFloat(box.getAttribute('data-cc-auto')) || 0;
      if (!bin || !bin.children.length) return;
      function giro() { return bin.scrollWidth / copie; }
      function centra() { bin.style.scrollBehavior = 'auto'; bin.scrollLeft = giro(); bin.style.scrollBehavior = ''; }
      function correggi() {
        var g = giro(); if (!g) return;
        if (bin.scrollLeft < g * 0.5) { bin.style.scrollBehavior = 'auto'; bin.scrollLeft += g; bin.style.scrollBehavior = ''; }
        else if (bin.scrollLeft > g * 1.5) { bin.style.scrollBehavior = 'auto'; bin.scrollLeft -= g; bin.style.scrollBehavior = ''; }
      }
      centra();
      window.addEventListener('resize', centra);
      var t;
      bin.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(correggi, vel ? 0 : 140); }, { passive: true });

      function passo() { var c = bin.children[0]; var gap = parseFloat(getComputedStyle(bin).columnGap) || 0; return c ? c.getBoundingClientRect().width + gap : 300; }
      box.querySelectorAll('[data-cc-dir]').forEach(function (b) {
        b.addEventListener('click', function () { correggi(); bin.scrollBy({ left: passo() * parseInt(b.getAttribute('data-cc-dir'), 10), behavior: 'smooth' }); });
      });

      if (!vel || riduci) return;
      box.classList.add('cc-giostra--auto');
      var ferma = false, visibile = true, riprendi, ultimo = null, resto = 0;
      function pausa() { ferma = true; clearTimeout(riprendi); }
      function riparti(ms) { clearTimeout(riprendi); riprendi = setTimeout(function () { ferma = false; }, ms); }
      box.addEventListener('mouseenter', pausa);
      box.addEventListener('mouseleave', function () { riparti(200); });
      box.addEventListener('touchstart', pausa, { passive: true });
      box.addEventListener('touchend', function () { riparti(3500); }, { passive: true });
      box.addEventListener('focusin', pausa);
      box.addEventListener('focusout', function () { riparti(500); });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visibile = en[0].isIntersecting; }).observe(box);
      function frame(ts) {
        if (ultimo !== null && !ferma && visibile && !document.hidden) {
          resto += vel * (ts - ultimo) / 1000;
          var px = Math.floor(resto);
          if (px >= 1) { bin.scrollLeft += px; resto -= px; correggi(); }
        }
        ultimo = ts; requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    });
  }

  /* ---------- video in sequenza (momenti) ---------- */
  function initVideo(root) {
    (root || document).querySelectorAll('video[data-cc-playlist]').forEach(function (v) {
      if (v.hasAttribute('data-cc-pronta')) return;
      v.setAttribute('data-cc-pronta', '');
      var lista = v.getAttribute('data-cc-playlist').split('|').filter(Boolean), i = 0;
      if (lista.length < 2) { v.loop = true; return; }
      v.loop = false;
      v.addEventListener('ended', function () { i = (i + 1) % lista.length; v.src = lista[i]; v.play().catch(function () {}); });
    });
  }

  function initTutto() { initReveal(); initParallax(); initNeve(); initMomenti(); initConto(); initGalleria(); initProdotto(); initBarra(); initGiostra(); initVideo(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTutto); else initTutto();
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); initGiostra(e.target); initVideo(e.target); initNeve(); initMomenti(); initConto(); initGalleria(); initProdotto(); });
})();
